<template>
  <input
    :class="['input', { readonly }]"
    :id="id"
    type="range"
    :readonly="readonly"
    :value="value"
    :required="required"
    :min="min"
    :max="max"
    :step="step"
    v-on="inputListeners"
  />
</template>

<script>
export default {
  props: {
    id: { type: String, required: true },
    value: [String, Number],
    min: [String, Number],
    max: [String, Number],
    step: [String, Number],
    readonly: [String, Boolean],
    required: [String, Boolean]
  },
  computed: {
    inputListeners() {
      return {
        ...this.$listeners,
        input: event => {
          this.$emit("input", event.target.value);
        }
      };
    }
  }
};
</script>

<style scoped lang="scss">
.input {
  box-sizing: border-box;
  display: block;
  flex: 1 1 auto;
  width: 100%;
  height: var(--input-height);
  margin: 0;
}
.readonly {
  background: transparent;
}
</style>
